import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  version: "1.0",
  viewBox: "0 0 616 615"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16.6 1.5C8.3 4.4 2.6 11.2 1 19.9c-1.3 7-1.4 271.3-.1 279.3 1.7 10.2 9 17.6 19.4 19.8 10.6 2.1 20.5-2.9 25.4-12.8l2.8-5.7.3-126.3L49 48h126.3c120.3 0 126.4-.1 130.2-1.9 11.1-5.1 16.9-18.3 13.1-29.8-1.8-5.3-6.7-10.8-12.6-13.9C302.6.6 296.8.5 161.5.3 42.2.1 19.9.3 16.6 1.5m563.6 296c-5.5 2.8-9.9 8.1-12 14.4-.9 2.5-1.2 36.4-1.2 128.7V566l-126.7.2c-143.1.3-130.1-.4-138.2 8.3-11.1 12-6.8 31.3 8.4 38.2 3.8 1.7 10.9 1.8 145.5 1.4 153.9-.4 145.1 0 151.4-5.9 1.6-1.5 3.9-5 5.2-7.7l2.4-5v-141c0-134.4-.1-141.2-1.9-145-3.8-8.4-11.8-13.7-21.6-14.3-5-.3-6.9.1-11.3 2.3" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "expand-2"}) } }